import React from 'react'
import { Link } from 'react-router-dom'

export const Navbar = () => {


  return (
    <div>
        <nav className="bg-white border-gray-200 px-2 sm:px-4 py-2.5 rounded dark:bg-amber-400 ">
  <div className="container flex flex-wrap justify-between items-center mx-auto">
    <Link to="/" className="flex items-center">
        <span className="self-center text-xl font-semibold whitespace-nowrap  ml-0 text-blue-900">Cocktailpedia</span>
    </Link>
     <Link to="/favourite" className="flex items-center">
        <span className="self-center text-xl font-semibold whitespace-nowrap  ml-0 text-blue-900"></span>
    </Link>

  </div>
</nav>
    </div>
  )
}
